import { render, staticRenderFns } from "./BulkAccessModal.vue?vue&type=template&id=b85ae120&scoped=true"
import script from "./BulkAccessModal.js?vue&type=script&lang=js&external"
export * from "./BulkAccessModal.js?vue&type=script&lang=js&external"
import style0 from "./BulkAccessModal.vue?vue&type=style&index=0&id=b85ae120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85ae120",
  null
  
)

export default component.exports